import React from "react";
import {useTheme, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography} from "@mui/material";
import CustomButton from "./CustomButton";
import CloseIcon from "@mui/icons-material/Close";

const CustomDialog = ({open, onClose, maxWidth, title, subtitle, content, actions, customStyles, globalSx, hasDividers, hasCloseIcon}) => {

    const theme = useTheme();

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth={maxWidth} 
            fullWidth 
        >
            <DialogTitle sx={{color: theme.typography.primary, fontWeight: 600, fontSize: 22, display: "flex", justifyContent: "space-between", alignItems: "center", ...globalSx?.title}}>
                <Box>
                    <Typography variant="h6" sx={{color: theme.typography.primary, fontWeight: 600, fontSize: 22}}>
                        {title}
                    </Typography>

                    <Typography variant="body2" sx={{color: theme.typography.secondary, fontWeight: 400}}>
                        {subtitle || ""}
                    </Typography>
                </Box>

                {(hasCloseIcon !== false || hasCloseIcon === undefined) && 
                    <IconButton onClick={onClose}>
                        <CloseIcon sx={{...globalSx?.titleIcon, color: theme.typography.secondary}} />
                    </IconButton>
                }
            </DialogTitle>

            <DialogContent dividers={hasDividers || false} sx={{borderBottom: "none", padding: "24px 24px 16px", ...globalSx?.content}}>
                {content}
            </DialogContent>

            {actions && (
                <DialogActions sx={{padding: "16px 20px 30px", ...globalSx?.actions}}>
                    {actions?.map((action, index) => (
                        <CustomButton 
                            key={index}
                            variant={action.variant ? action.variant : "contained"}
                            label={action.label}
                            customStyles={action?.customStyles ? action?.customStyles : customStyles?.actions}
                            onClick={action.onClick}
                            disableRipple={action.disableRipple ? action.disableRipple : false}
                            startIcon={action.startIcon || null}
                        />
                    ))}
                </DialogActions>
            )}
        </Dialog>
    )
}

export default CustomDialog
